import { CIcon } from '~/icons/types'

export const ciBoats: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.2 18.098a1.69 1.69 0 0 1-1.155-.463 2.718 2.718 0 0 0-1.238-.592l2.45-5.445a.5.5 0 0 0-.457-.7h-5.681l-3.657-3.845a.5.5 0 0 0-.362-.155h-2.825l-2.363-1.89a.5.5 0 0 0-.312-.11h-1a.5.5 0 0 0-.5.5v1.5h-.8a.5.5 0 0 0-.486.381L3.51 12.6H1.4a.5.5 0 0 0-.488.39l-.6 2.7a.5.5 0 0 0 .033.316l.913 2.011a1.262 1.262 0 0 1-.458.082.5.5 0 0 0 0 1 2.5 2.5 0 0 0 1.644-.637 1.693 1.693 0 0 1 1.156-.463 1.53 1.53 0 0 1 1.091.443 2.5 2.5 0 0 0 3.354.02 1.687 1.687 0 0 1 1.155-.463c.389.008.76.163 1.04.433a2.65 2.65 0 0 0 1.76.667 2.51 2.51 0 0 0 1.645-.636 1.68 1.68 0 0 1 1.155-.464 1.534 1.534 0 0 1 1.092.443 2.494 2.494 0 0 0 3.352.02 1.693 1.693 0 0 1 1.156-.463c.39.008.761.163 1.041.433a2.66 2.66 0 0 0 1.76.667.5.5 0 1 0 0-1ZM7.1 5.898h.324l1.25 1H7.1v-1Zm-1.408 2h7.193l.951 1H7.5a.5.5 0 1 0 0 1h7.288l.951 1H15.2a.503.503 0 0 0-.158.026l-5.023 1.674h-5.48l1.153-4.7Zm13.992 9.207a3.079 3.079 0 0 0-1.044.562 1.515 1.515 0 0 1-2.13-.01 2.5 2.5 0 0 0-1.71-.659 2.65 2.65 0 0 0-1.76.667c-.28.271-.651.426-1.04.433a1.686 1.686 0 0 1-1.155-.464 2.511 2.511 0 0 0-1.645-.636c-.648 0-1.274.238-1.76.667a1.515 1.515 0 0 1-2.131-.01 2.5 2.5 0 0 0-1.709-.657 2.462 2.462 0 0 0-1.491.472l-.785-1.728.476-2.144h8.3a.499.499 0 0 0 .158-.026l5.023-1.674h6.745l-2.342 5.207Z'
    },
    {
      d:
        'M19.523 13.252a.5.5 0 0 0-.67.224l-.2.4a.499.499 0 0 0 .606.698.5.5 0 0 0 .29-.251l.199-.4a.5.5 0 0 0-.225-.671Zm-2.299 0a.5.5 0 0 0-.671.224l-.2.4a.5.5 0 1 0 .894.447l.2-.4a.5.5 0 0 0-.223-.671Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'boats',
  type: 'thin'
}
